namespace $.$$ {

	$.$shm_hitalama_compat_fqn_install( $ as any )
	$.$shm_hitalama_compat_crypto_current_install()
	$.$shm_hitalama_baza_diff_cache_repair_install()
	$.$shm_hitalama_baza_saving_install()
	$.$shm_hitalama_baza_gift_pass_install()
	$.$shm_hitalama_baza_diff_idle_install()

	// http://localhost:9080/shm/hitalama/app/-/test.html
	// http://localhost:9080/shm/hitalama/app/-/test.html#!domain_page=true
	// http://localhost:9080/shm/hitalama/app/-/test.html#!section=hidden_reg

	const master_self = new URL( '/', $.$mol_dom_context.location.origin ).toString()
	$.$giper_baza_yard.masters = ()=> [ master_self ]
	
	export class $shm_hitalama_app extends $.$shm_hitalama_app {
		analysis_fqn() { return '$' + 'shm2_vk_posts' }

		telemetry_auto() {
			this.$.$shm_hitalama_telemetry_sentry.start()
			this.$.$shm_hitalama_telemetry_sentry.context_update({
				version: this.version_data_version(),
				user_id: this.$.$giper_baza_auth.current().pass().lord().str,
				client_id: this.mcp_client().client_id(),
				map_id: this.map_id() || '',
				mode: this.$.$shm_hitalama_app.tg_params()
					? 'telegram'
					: this.$.$mol_state_arg.value( 'extension' ) ? 'extension'
					: this.$.$mol_state_arg.value( 'fullscreen_widget' ) ? 'fullscreen' : 'web',
				section: this.$.$mol_state_arg.value( 'section' ) || '',
			})
			return null
		}

		pass_income_auto() {
			this.$.$shm_hitalama_app_pass_income_patch()
			return null
		}

		workspace_auto() {
			// The same bundle serves embedded widgets; workspace side panels,
			// favorite maps and document hotkeys must not mount in that mode.
			if( this.$.$mol_state_arg.value( 'extension' ) ) return []
			return [
				this.favorite_maps_retain_auto(),
				this.map_visit_auto(),
				this.side_views_auto(),
				this.command_palette_keydown_listener(),
			]
		}

		projects_session_identity_auto() {
			this.$.$shm_projects_goal_api.initiator_provider = ()=> {
				const profile = this.$.$shm_hitalama_profile.current()
				if( !profile ) return null
				return {
					profile_id: profile.link().toString(),
					profile_name: profile.Login()?.val() ?? '',
					github_token: this.$.$shm_hitalama_settings.github_token(),
				}
			}
			return null
		}

		projects_team_config_auto() {
			this.$.$shm_projects_config.connection_provider = ()=> this.team_connection()
			return null
		}

		profile_name_publish_auto() {
			this.$.$mol_error_fence(
				()=> this.$.$shm_hitalama_profile.user_name_publish(),
				()=> null,
				promise => promise,
			)
			return null
		}

		current_user_id() {
			return this.$.$giper_baza_auth.current().pass().lord().str
		}

		team_current() {
			return $shm_hitalama_resilience_read(
				'team',
				'selected team',
				()=> ( this.Teams() as any ).selected_team() as $shm_hitalama_team | null,
				null,
			)
		}

		team_connection() {
			return $shm_hitalama_resilience_read(
				'team',
				'projects connection',
				()=> {
					const team = this.team_current()
					if( !team ) return null
					const url = team.projects_api_url().trim()
					const token = team.projects_api_token().trim()
					if( !url || !token ) return null
					return { url, token }
				},
				null,
			)
		}

		team_configured() {
			return Boolean( this.team_connection() )
		}

		menu_spreads() {
			const spreads = { ... super.menu_spreads() }
			if( !this.team_configured() ) {
				const optional = spreads as Partial< typeof spreads >
				delete optional.projects
			}
			return spreads
		}

		@ $mol_memo.field
		get $() {
			return super.$.$mol_ambient({
				$shm_projects_draft_note: ( id: string, next?: string )=> this.project_draft( id, next ),
				$shm_projects_tasks_list: ( project_id: string )=> this.project_tasks( project_id ),
				$shm_projects_task_get: ( project_id: string, id: string )=> this.project_task( project_id, id ),
				$shm_projects_task_create: ( project_id: string )=> this.project_task_create( project_id ),
				$shm_projects_task_create_enabled: ( project_id: string )=> this.project_task_create_enabled( project_id ),
				$shm_projects_task_import: ( project_id: string, task: $shm_projects_task_record )=> this.project_task_import( project_id, task ),
				$shm_projects_task_update: ( project_id: string, id: string, change: Partial< $shm_projects_task_record > )=> this.project_task_update( project_id, id, change ),
				$shm_projects_users_options: ()=> this.project_users_options(),
				$shm_projects_access_view: ( project_id: string )=> this.project_access( 'visible', project_id ),
				$shm_projects_access_prerelease: ( project_id: string )=> this.project_access( 'prerelease', project_id ),
				$shm_projects_access_release: ( project_id: string )=> this.project_access( 'release', project_id ),
				$shm_hitalama_map_widget_visible: ( widget: $shm_hitalama_map_widget )=> this.map_widget_visible( widget ),
			} as any)
		}

		map_widget_visible( widget: $shm_hitalama_map_widget ) {
			return $shm_hitalama_resilience_read(
				'team',
				`widget access ${ widget.link().str }`,
				()=> {
					const data = widget.Data()?.val() ?? {}
					if( typeof data.projects_project_id === 'string' ) {
						return this.team_configured() && this.project_access( 'visible', data.projects_project_id )
					}

					if( typeof data.projects_module_id === 'string' ) {
						const project = this.$.$shm_projects_data.records().find( item =>
							item.modules?.some( module => module.id === data.projects_module_id )
						)
						return this.team_configured() && ( project ? this.project_access( 'visible', project.id ) : true )
					}

					return true
				},
				false,
			)
		}

		project_users_options() {
			return $shm_hitalama_resilience_read(
				'team',
				'project users',
				()=> {
					const members = this.team_current()?.member_records() ?? []
					return Object.fromEntries( members.map( ( member: $shm_hitalama_team_member )=> {
						const id = member.User_id()?.val() || member.link().toString()
						return [ id, member.Name()?.val() || id ]
					} ) )
				},
				{} as Record< string, string >,
			)
		}

		project_access( kind: 'visible' | 'prerelease' | 'release', project_id: string ) {
			return $shm_hitalama_resilience_read(
				'team',
				`project access ${ kind }`,
				()=> {
					const member = this.team_current()?.member_by_user( this.current_user_id() )
					return member?.project_allowed( kind, project_id ) ?? false
				},
				false,
			)
		}

		title(): string {
			return 'Hitalama'
		}

		version_data_default() {
			return {
				version: '-',
				date: '-',
			}
		}

		private version_loaded?: { version?: string, date?: string }
		private static version_requests = new Map< string, {
			promise: Promise< { version?: string, date?: string } >,
			data?: { version?: string, date?: string },
		} >()

		static version_data_fetch( url: string ) {
			const cached = this.version_requests.get( url )
			if( cached ) return cached.data ?? cached.promise
			// A footer can lose its reactive subscribers during navigation. Keep
			// one pending/result request per URL, independent of that view lifetime.
			if( url.includes( '?poll=' ) ) {
				for( const key of this.version_requests.keys() ) {
					if( key.includes( '?poll=' ) ) this.version_requests.delete( key )
				}
			}
			const entry: { promise: Promise< { version?: string, date?: string } >, data?: { version?: string, date?: string } } = {
				promise: this.$.$mol_dom_context.fetch( url ).then( response => {
					if( !response.ok ) throw new Error( `Version request failed: HTTP ${ response.status }` )
					return response.json() as Promise< { version?: string, date?: string } >
				}).then( data => entry.data = data ),
			}
			this.version_requests.set( url, entry )
			return entry.promise
		}

		@ $mol_mem_key
		static version_data_request( url: string ) {
			return this.$.$mol_error_fence(
				()=> this.$.$mol_wire_sync( this ).version_data_fetch( url ),
				()=> ({ version: '-', date: '-' }),
				promise => $mol_fail_hidden( promise ),
			)
		}

		version_data() {
			if( this.version_loaded ) return this.version_loaded
			const data = this.$.$shm_hitalama_app.version_data_request( `/shm/hitalama/app/_version.json?loaded=${ Math.floor( performance.timeOrigin ) }` )
			this.version_loaded = data
			return data
		}

		version_data_latest() {
			const poll = Math.floor( $mol_state_time.now( 60_000 ) / 60_000 )
			return this.$.$shm_hitalama_app.version_data_request( `/shm/hitalama/app/_version.json?poll=${ poll }` )
		}

		version_data_version() {
			return String( this.version_data().version || this.version_data_default().version )
		}

		version_data_date() {
			return String( this.version_data().date || this.version_data_default().date )
		}

		version_data_available() {
			return String( this.version_data_latest().version || this.version_data_version() )
		}

		map_version_notice() {
			if( this.spread() !== 'map' || !this.map_id() ) return []
			const notice = this.Map_version()
			return notice.outdated() ? [ notice ] : []
		}

		internal_auth_spread( spread: string ) {
			return spread === 'enter' || spread === 'register' || spread === 'enterkey' || spread === 'hidden_reg'
		}

		Spread_current() {
			const spread = this.spread()
			if( this.internal_auth_spread( spread ) ) return this.Spread_default()
			return this.Spread( spread )
		}

		login(): string {
			// console.log('this.profiles()', this.profiles().keys())
			return this.$.$shm_hitalama_profile.current()?.Login()?.val() ?? ''
		}

		entergate_pending_login_key() {
			return '$' + 'hitalama_profile_gate.pending_login'
		}

		entergate_pending_login( next?: string | null ) {
			return this.$.$mol_state_local.value< string >( this.entergate_pending_login_key(), next ) ?? ''
		}

		entergate_auth_exists() {
			return Boolean( this.$.$mol_state_local.value< string >( '$giper_baza_auth' ) )
		}

		baza_sync_auto() {
			this.$.$giper_baza_glob.yard().sync()
			return null
		}

		client_pass_publish_auto() {
			if( !this.entergate_auth_exists() ) return null
			this.$.$shm_hitalama_profile.home().Hitalama_profile()?.remote()
			return null
		}

		@ $mol_action
		entergate_pending_auto() {
			const login = this.entergate_pending_login().trim()
			if( !login ) {
				if( this.entergate_auth_exists() && !this.login() ) {
					this.$.$shm_hitalama_profile.home().Hitalama_profile()?.remote()
				}
				return null
			}

			const auth = this.$.$giper_baza_auth.current()
			const profile = this.$.$giper_baza_glob
				.land_grab( [[ null, this.$.$giper_baza_rank_make( 'post', 'just' ) ]] )
				.Data( this.$.$shm_hitalama_profile )
			profile?.Login( null )!.val( login )
			profile?.Pass_key( null )!.val( auth.toString() )
			profile?.version( $shm_hitalama_profile_migration.latest_version() )
			if( this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) profile?.selfhosted_defaults_ensure()

			if( profile ) {
				const home = $shm_hitalama_profile.home()
				home.Hitalama_profile( null )!.remote( profile )
				this.entergate_pending_login( null )
				this.$.$mol_state_arg.value( 'section', null )
				this.$.$shm_hitalama_app.selfhosted_tauri_logout( false )
			}

			return null
		}

		static selfhosted_tauri_logout_key() {
			return `${ this }.selfhosted_tauri_logout`
		}

		static selfhosted_tauri_logout( next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( this.selfhosted_tauri_logout_key(), next )
		}

		@ $mol_action
		selfhosted_tauri_admin_auto() {
			if( !this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) return null

			const login = 'admin'
			const password = 'admin'
			const domain = this.$.$shm_hitalama_domain.instance()
			const profiles = domain.profiles_ensure()

			const existed = profiles.key( login )?.remote()
			if( existed ) {
				existed.selfhosted_defaults_ensure()
				if( $shm_hitalama_app.selfhosted_tauri_logout() ) return null
				if( this.login() ) return null
				existed.enter( password )
				return null
			}

			const profile = profiles.key( login, 'auto' )?.remote( this.$.$shm_hitalama_profile.current() )
			if( !profile ) return null

			profile.Login(null)!.val( login )
			profile.version( $shm_hitalama_profile_migration.latest_version() )
			profile.password( password )
			profile.selfhosted_defaults_ensure()

			if( $shm_hitalama_app.selfhosted_tauri_logout() ) return null
			if( this.login() ) return null

			const home = $shm_hitalama_profile.home()
			home.Hitalama_profile(null)!.remote( profile )
			return null
		}

		Map(): $.$shm_hitalama_map_book {
			this.guest_app_query_drop()
			return this.Maps().Book( this.map_id() )
		}

		guest_app_query_drop() {
			const location = this.$.$mol_dom_context.location
			const uri = new URL( location.href )
			if( uri.searchParams.get( 'guest_app' ) !== '1' ) return null

			uri.searchParams.delete( 'guest_app' )
			this.$.$mol_dom_context.history.replaceState( null, '', `${ uri.pathname }${ uri.search }${ uri.hash }` )
			return null
		}

		document() {
			return this.$.$mol_dom_context.document
		}

		@ $mol_action
		add_map( access_level: keyof ReturnType<typeof $shm_hitalama_map.access_level_to_ranks> ) {
			return this.Maps().add_map( access_level )
		}

		@ $mol_mem
		command_palette_keydown_handler() {
			return $mol_wire_async( ( event: KeyboardEvent ) => {
				if( event.code === 'KeyP' && ( event.ctrlKey || event.metaKey ) && event.shiftKey ) {
					event.preventDefault()
					this.command_palette_opened( true )
					return
				}

				if( event.code === 'KeyY' && ( event.ctrlKey || event.metaKey ) && event.shiftKey ) {
					event.preventDefault()
					const opened = this.$.$mol_state_arg.value( 'domain_page' ) === 'true'
					this.$.$mol_state_arg.value( 'domain_page', opened ? null : 'true' )
					return
				}

				if( event.key === 'Escape' && this.command_palette_opened() ) {
					event.preventDefault()
					this.command_palette_opened( false )
					return
				}

				const fullscreen_disable_key = this.$.$shm_hitalama_settings.fullscreen_disable_key()
				if( !event.defaultPrevented && fullscreen_disable_key && event.key === fullscreen_disable_key && this.$.$mol_state_arg.value( 'fullscreen_widget' ) ) {
					event.preventDefault()
					this.$.$mol_state_arg.value( 'fullscreen_widget', null )
				}
			} )
		}

		@ $mol_mem
		Fullscreen(): $.$shm_hitalama_app_fullscreen {
			$mol_wire_solid()
			return super.Fullscreen()
		}

		recovery_key( area: $shm_hitalama_resilience_area, error: unknown ) {
			const normalized = error instanceof Error ? error : new Error( String( error ) )
			return JSON.stringify({ area, name: normalized.name, message: normalized.message })
		}

		recovery_data( key: string ) {
			return this.$.$mol_error_fence(
				()=> JSON.parse( key ) as { area: $shm_hitalama_resilience_area, name: string, message: string },
				()=> ({ area: 'application' as const, name: 'Error', message: '' }),
			)
		}

		recovery_title( key: string ) {
			return 'Раздел временно недоступен'
		}

		recovery_message( key: string ) {
			return $shm_hitalama_resilience_error_message( this.recovery_data( key ).area )
		}

		recovery_details( key: string ) {
			const data = this.recovery_data( key )
			return `${ data.name }: ${ data.message }`
		}

		recovery_retry_visible( key: string ) {
			return true
		}

		recovery_page( area: $shm_hitalama_resilience_area, error: unknown ) {
			$shm_hitalama_resilience_report( area, error )
			return this.Recovery_page( this.recovery_key( area, error ) )
		}

		loading_watch( area: $shm_hitalama_resilience_area, promise: PromiseLike< unknown > ) {
			$shm_hitalama_telemetry_sentry.promise_watch( promise, `${ area }:page` )
		}

		sub_content(): readonly ( $mol_view )[] {
			if( $shm_hitalama_app.tg_params() ) { //hack tg app
				return [
					this.Map(),
					this.Fullscreen(),
					... this.domain_page_view(),
				]
			}

			const is_extension = this.$.$mol_state_arg.value( 'extension' )!
			if( is_extension ) return [
				this.Ext(),
				... this.domain_page_view(),
			]

			const No_auth_page = (this.no_auth_pages() as any)[ this.spread() ]
			if( No_auth_page ) return [No_auth_page]

			if( !this.login() ) return [
				... super.sub(),
				... this.domain_page_view(),
			]

			return [
				... super.sub(),
				... this.domain_page_view(),
			]
		}

		sub(): readonly ( $mol_view )[] {
			return this.$.$mol_error_fence(
				()=> this.sub_content(),
				error => [ this.recovery_page( 'application', error ), this.Overlay_panel() ],
				promise => {
					this.loading_watch( 'application', promise )
					return [ this.Book(), this.Overlay_panel() ]
				},
			)
		}

		chat_view(): readonly ( any )[] {
			if( !this.chat_opened() ) return []
			const project = this.team_configured()
				&& this.$.$mol_state_arg.value( 'section' ) === 'projects'
				&& this.$.$mol_state_arg.value( 'project' )
			return project
				? [ this.Project_chat() ]
				: [ this.map_chat() ]
		}

		map_chat() {
			const codex = this.$.$shm_hitalama_settings.agent_backend() === 'codex'
			if( !this.agent_map_id() ) return codex ? this.General_codex() : this.General_chat()
			return codex
				? this.Map_codex()
				: this.Chat()
		}

		agent_map_id() {
			const section = this.spread()
			return section === 'map' || section === 'maps' ? this.map_id() || '' : ''
		}

		project_draft( id: string, next?: string ): string {
			const fallback = `$shm_projects_draft_note(${ id })`
			if( next !== undefined ) {
				this.project_draft_pending( id, true )
				this.$.$mol_state_local.value( fallback, next )
				$mol_wire_async( this ).project_draft_store( id ).catch( $mol_fail_log )
				return next
			}
			if( this.project_draft_pending( id ) ) {
				return String( this.$.$mol_state_local.value( fallback ) ?? '' )
			}
			return this.$.$mol_error_fence(
				()=> {
					const domain = this.$.$shm_hitalama_domain.instance()
					const stored = domain.project_draft( id )
					const local = String( this.$.$mol_state_local.value( fallback ) ?? '' )
					if( !stored && local ) {
						this.project_draft_pending( id, true )
						$mol_wire_async( this ).project_draft_store( id ).catch( $mol_fail_log )
						return local
					}
					return stored
				},
				()=> String( this.$.$mol_state_local.value( fallback ) ?? '' ),
				promise => $mol_fail_hidden( promise ),
			)
		}

		project_draft_store( id: string ) {
			const fallback = `$shm_projects_draft_note(${ id })`
			const value = String( this.$.$mol_state_local.value( fallback ) ?? '' )
			const stored = this.$.$shm_hitalama_domain.instance().project_draft( id, value )
			this.project_draft_pending( id, false )
			return stored
		}

		@ $mol_mem_key
		project_draft_pending( id: string, next?: boolean ) {
			return next ?? false
		}

		project_task_record( project_id: string, task: $shm_hitalama_project_task ): $shm_projects_task_record {
			return {
				id: task.link().toString(),
				legacy_id: task.Legacy_id()?.val() || '',
				project_id,
				title: task.Title()?.val() || '',
				description: task.Description()?.val() || '',
				result: task.Result()?.val() || '',
				run_id: task.Run_id()?.val() || '',
				status: ( task.Status()?.val() || 'draft' ) as $shm_projects_task_record['status'],
				creator_id: task.Creator_id()?.val() || '',
				creator_name: task.Creator_name()?.val() || '',
				assignee_id: task.Assignee_id()?.val() || '',
				assignee_name: task.Assignee_name()?.val() || '',
				acceptance_criteria: task.Acceptance_criteria()?.val() || '',
				priority: ( task.Priority()?.val() || 'normal' ) as $shm_projects_task_record['priority'],
				revision: task.Revision()?.val() || 0,
				planned_revision: task.Planned_revision()?.val() || 0,
				mode: ( task.Mode()?.val() || 'research' ) as $shm_projects_task_record['mode'],
				pinned: task.Pinned()?.val() ?? false,
				archived: task.Archived()?.val() ?? false,
				created_at: task.Created_at()?.val() || 0,
				updated_at: task.Updated_at()?.val() || 0,
			}
		}

		project_task_entity( id: string ) {
			return this.$.$giper_baza_glob.Pawn( new this.$.$giper_baza_link( id ), this.$.$shm_hitalama_project_task )
		}

		project_tasks( project_id: string ) {
			const project = this.$.$shm_hitalama_domain.instance().project_entity( project_id )
			const tasks = project?.Tasks()?.remote_list() ?? []
			return tasks
				.map( task => this.project_task_record( project_id, task ) )
				.sort( ( left, right )=> right.updated_at - left.updated_at )
		}

		project_task( project_id: string, id: string ) {
			const listed = this.project_tasks( project_id ).find( task => task.id === id )
			if( listed ) return listed
			return this.project_task_record( project_id, this.project_task_entity( id ) )
		}

		project_task_create( project_id: string ) {
			const project = this.$.$shm_hitalama_domain.instance().project_entity( project_id, true)
			if( !project ) throw new Error( `Unknown project: ${ project_id }` )
			const tasks = project.Tasks( null )!
			const number = ( tasks.remote_list() ?? [] ).reduce( ( maximum, task )=> Math.max(
				maximum,
				Number( task.Title()?.val()?.match( /^Задача (\d+)$/ )?.[1] || 0 ),
			), 0 ) + 1
			const now = Date.now()
			const profile = this.$.$shm_hitalama_profile.home().Hitalama_profile()?.remote()
			const profile_id = profile?.link().toString() ?? ''
			const profile_name = profile?.Login()?.val() ?? ''
			const task = project.land().area_make().Data( this.$.$shm_hitalama_project_task )
			task.Legacy_id( null )!.val( '' )
			task.Title( null )!.val( `Задача ${ number }` )
			task.Project_id( null )!.val( project_id )
			task.Description( null )!.val( '' )
			task.Result( null )!.val( '' )
			task.Run_id( null )!.val( '' )
			task.Status( null )!.val( 'draft' )
			task.Creator_id( null )!.val( profile_id )
			task.Creator_name( null )!.val( profile_name )
			task.Assignee_id( null )!.val( profile_id )
			task.Assignee_name( null )!.val( profile_name )
			task.Acceptance_criteria( null )!.val( '' )
			task.Priority( null )!.val( 'normal' )
			task.Revision( null )!.val( 0 )
			task.Planned_revision( null )!.val( 0 )
			task.Mode( null )!.val( 'research' )
			task.Pinned( null )!.val( false )
			task.Archived( null )!.val( false )
			task.Created_at( null )!.val( now )
			task.Updated_at( null )!.val( now )
			tasks.remote_add( task )
			return this.project_task_record( project_id, task )
		}

		project_task_create_enabled( project_id?: string ) {
			return true
		}

		project_task_import( project_id: string, source: $shm_projects_task_record ) {
			const project = this.$.$shm_hitalama_domain.instance().project_entity( project_id, true )
			if( !project ) throw new Error( `Unknown project: ${ project_id }` )
			const tasks = project.Tasks( null )!
			const legacy_id = source.legacy_id || source.id
			const existing = tasks.remote_list().find( task => task.Legacy_id()?.val() === legacy_id )
			if( existing ) return this.project_task_record( project_id, existing )

			const task = project.land().area_make().Data( this.$.$shm_hitalama_project_task )
			task.Legacy_id( null )!.val( legacy_id )
			task.Title( null )!.val( source.title )
			task.Project_id( null )!.val( project_id )
			task.Description( null )!.val( source.description )
			task.Result( null )!.val( source.result )
			task.Run_id( null )!.val( source.run_id )
			task.Status( null )!.val( source.status )
			task.Creator_id( null )!.val( source.creator_id )
			task.Creator_name( null )!.val( source.creator_name )
			task.Assignee_id( null )!.val( source.assignee_id )
			task.Assignee_name( null )!.val( source.assignee_name )
			task.Acceptance_criteria( null )!.val( source.acceptance_criteria )
			task.Priority( null )!.val( source.priority )
			task.Revision( null )!.val( source.revision )
			task.Planned_revision( null )!.val( source.planned_revision )
			task.Mode( null )!.val( source.mode )
			task.Pinned( null )!.val( source.pinned ?? false )
			task.Archived( null )!.val( source.archived ?? false )
			task.Created_at( null )!.val( source.created_at )
			task.Updated_at( null )!.val( source.updated_at )
			tasks.remote_add( task )
			return this.project_task_record( project_id, task )
		}

		project_task_update( project_id: string, id: string, change: Partial< $shm_projects_task_record > ) {
			const task = this.project_task_entity( id )
			if( change.legacy_id !== undefined ) task.Legacy_id( null )!.val( change.legacy_id )
			if( change.title !== undefined ) task.Title( null )!.val( change.title )
			if( change.description !== undefined ) task.Description( null )!.val( change.description )
			if( change.result !== undefined ) task.Result( null )!.val( change.result )
			if( change.run_id !== undefined ) task.Run_id( null )!.val( change.run_id )
			if( change.status !== undefined ) task.Status( null )!.val( change.status )
			if( change.creator_id !== undefined ) task.Creator_id( null )!.val( change.creator_id )
			if( change.creator_name !== undefined ) task.Creator_name( null )!.val( change.creator_name )
			if( change.assignee_id !== undefined ) task.Assignee_id( null )!.val( change.assignee_id )
			if( change.assignee_name !== undefined ) task.Assignee_name( null )!.val( change.assignee_name )
			if( change.acceptance_criteria !== undefined ) task.Acceptance_criteria( null )!.val( change.acceptance_criteria )
			if( change.priority !== undefined ) task.Priority( null )!.val( change.priority )
			if( change.revision !== undefined ) task.Revision( null )!.val( change.revision )
			if( change.planned_revision !== undefined ) task.Planned_revision( null )!.val( change.planned_revision )
			if( change.mode !== undefined ) task.Mode( null )!.val( change.mode )
			if( change.pinned !== undefined ) task.Pinned( null )!.val( change.pinned )
			if( change.archived !== undefined ) task.Archived( null )!.val( change.archived )
			task.Updated_at( null )!.val( change.updated_at ?? Date.now() )
			return this.project_task_record( project_id, task )
		}

		@ $mol_mem
		chat_opened( next?: boolean ) {
			const opened = this.$.$mol_state_local.value( `${ this }.chat_opened`, next ) ?? false
			if( next ) new this.$.$mol_after_frame( ()=> this.chat_bring() )
			return opened
		}

		chat_bring() {
			if( !this.chat_opened() ) return
			this.Book().dom_tree()
			const pages = this.Book().pages_deep()
			const chat = pages.at( -1 )
			const expected = this.chat_view()[0]?.Chat_page()
			if( !chat || chat !== expected ) return
			const book = this.Book().dom_node() as HTMLElement
			const page = chat.dom_node() as HTMLElement
			book.scroll({
				left: page.offsetLeft + page.offsetWidth - book.offsetWidth,
				behavior: 'smooth',
			})
		}

		maps_list_visible( next?: boolean ) {
			return this.$.$mol_state_local.value( `${ this }.maps_list_visible`, next ) ?? true
		}

		projects_list_visible( next?: boolean ) {
			return this.$.$mol_state_local.value( `${ this }.projects_list_visible`, next ) ?? true
		}

		chat_width( next?: number ) {
			return this.$.$mol_state_local.value( `${ this }.chat_width`, next ) ?? super.chat_width()
		}

		@ $mol_mem
		process_monitor_opened( next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( `${ this }.process_monitor_opened`, next ) ?? false
		}

		process_monitor_view(): readonly ( any )[] {
			return this.process_monitor_opened() ? [this.Process_monitor()] : []
		}

		@ $mol_mem
		history_opened( next?: boolean ) {
			const value = this.$.$mol_state_arg.value(
				'map_history',
				next === undefined ? undefined : next ? 'true' : null,
			)
			return value === 'true'
		}

		@ $mol_action
		process_monitor_close( event?: Event | null ) {
			if( event ) this.process_monitor_opened( false )
			return event ?? null
		}

		history_close( event?: Event | null ) {
			if( event ) this.history_opened( false )
			return event ?? null
		}

		history_view(): readonly ( any )[] {
			return this.history_opened() && this.map_id() ? [ this.History() ] : []
		}

		side_views(): readonly ( any )[] {
			return [
				... this.process_monitor_view(),
				... this.history_view(),
				... this.chat_view(),
			]
		}

		domain_page_view(): readonly ( any )[] {
			return this.$.$mol_state_arg.value( 'domain_page' ) === 'true' ? [this.Domain_page()] : []
		}

		side_views_auto() {
			return this.side_views().map( view => view.auto?.() ?? null )
		}

		@ $mol_mem
		mcp_client() {
			return this.$.$shm_hitalama_mcp_client.make({
				app: ()=> this,
			})
		}

		mcp_client_auto() {
			return this.mcp_client().auto()
		}

		guide_section() { return this.spread() === 'map' ? 'maps' : this.spread() }
		guide_replaces_content() {
			return [ 'maps', 'applications', 'skills', 'knowledge', 'projects' ].includes( this.guide_section() )
		}
		guide_opened() {
			const help = this.$.$mol_state_arg.value( 'help' ), section = this.guide_section()
			if( help === section ) return true
			if( help || section === 'maps' || section === 'knowledge' ) return false
			const selected: Record<string,string> = { applications: 'component', skills: 'skill', projects: 'project', settings: 'settings', team: 'team_tab' }
			return section in selected ? !this.$.$mol_state_arg.value( selected[section] ) : [ 'profile', 'benchmark' ].includes( section )
		}
		guide_navigation(): $mol_view[] {
			switch( this.guide_section() ) {
				case 'maps': return [ this.Maps().Menu() ]
				case 'applications': return [ this.Applications().List() ]
				case 'skills': return [ this.Skills().List() ]
				case 'knowledge': return [ this.Knowledge().Menu() ]
				case 'projects': return [ this.Projects().Menu_page() ]
				case 'team': return this.team_current() ? [ this.Teams().Team_menu_page() ] : []
				default: return []
			}
		}

		book_pages_content() {
			const requested = this.spread()
			if( this.guide_opened() && this.guide_replaces_content() ) return [ this.Book_menu(), ...this.guide_navigation(), this.Guide(), ...this.side_views() ]
			// A partial/deep URL may select the map section before its ID arrives.
			// Keep the ordinary catalogue/auth flow instead of constructing a null link.
			const spread = requested === 'map' && !this.map_id() ? 'maps' : requested
			// A local run must keep its iframe mounted while unrelated profile
			// reads suspend. Authentication is checked without loading CRDT profile data.
			if( spread === 'benchmark' && this.entergate_auth_exists() ) return [
				this.Book_menu(),
				this.Benchmark(),
				... this.guide_opened() ? [ this.Guide() ] : [],
			]
			if( spread === 'projects' && !this.team_configured() ) return [
				this.Book_menu(),
				this.Teams(),
				... this.side_views(),
			]
			if( spread === 'knowledge' ) return [
				this.Book_menu(),
				this.Knowledge(),
				... this.side_views(),
			]
			if( spread === 'projects' && this.team_configured() ) return [
				this.Book_menu(),
				this.Projects(),
				... this.side_views(),
			]

			let login = this.login()
			if( !login ) {
				if( spread === 'map' ) return [
					this.Map(),
					... this.side_views()
				]

				if( this.entergate_auth_exists() ) {
					this.$.$shm_hitalama_profile.home().Hitalama_profile()?.remote()
					login = this.login()
				}

				if( !login ) return [ this.Auth_gate() ]
			}
			
			const spread_current = this.internal_auth_spread( spread ) ? '' : spread

			switch( spread_current ) {
				case 'map':
					return [
						this.Map(),
						... this.side_views()
					]
				case '':
				case 'lists':
					return super.book_pages()
			}

			const spread_view = spread_current === '' ? this.Spread_default() : this.Spread( spread_current )
			return [
				this.Book_menu(),
				spread_view,
				... this.guide_opened() ? [ this.Guide() ] : [],
				... this.side_views()
			]
		}

		@ $mol_mem
		favorite_maps_retain() {
			this.$.$mol_wire_solid()
			return this.$.$shm_hitalama_map_retain.make({
				catalog: ()=> this.Maps() as $shm_hitalama_map_catalog,
				active_id: ()=> {
					const section = this.$.$mol_state_arg.value( 'section' ) || 'maps'
					return [ 'maps', 'map' ].includes( section ) && !this.guide_opened() ? this.map_id() || '' : ''
				},
			})
		}

		favorite_maps_retain_auto() {
			return this.$.$mol_error_fence(
				()=> { this.favorite_maps_retain().reconcile(); return null },
				error => { this.favorite_maps_retain().clear(); $shm_hitalama_resilience_report( 'map', error ); return null },
				()=> null,
			)
		}

		book_pages() {
			const section = this.$.$mol_state_arg.value( 'section' ) || 'maps'
			const loading = this.$.$shm_hitalama_map_loading.navigate( [ 'map', 'maps' ].includes( section ) && !this.guide_opened() ? this.map_id() || '' : '' )
			return this.$.$mol_error_fence(
				()=> loading ? loading.step( 'navigation', 'Маршрутизация и создание страницы карты' ).read( ()=> this.book_pages_content() ) : this.book_pages_content(),
				error => { loading?.fail( error ); return [ this.Book_menu(), this.recovery_page( 'navigation', error ), ... this.side_views() ] },
				promise => {
					this.loading_watch( 'navigation', promise )
					return [ this.Book_menu(), ... this.side_views() ]
				},
			)
		}

		@ $mol_mem
		profiles() {
			return $shm_hitalama_domain.instance().profiles_ensure()
		}

		@ $mol_mem
		map_id() {
			return this.$.$mol_state_arg.value( 'map' )!
		}

		@ $mol_mem
		map_visit_auto() {
			const id = this.map_id()
			if( id ) ( this.Maps() as $shm_hitalama_map_catalog ).map_visit( id )
			return null
		}

		@ $mol_mem
		map() {
			let id = this.map_id()
			// if( $shm_hitalama_app.tg_params() ) { //hack tg app
			// 	id = $shm_hitalama_app.tg_params()?.map!
			// }
			return $giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_map )
		}

		static _tg_params: any
		@ $mol_mem
		static tg_params() {
			if( this._tg_params ) return this._tg_params

			const hash = document.location.hash
			if( !hash.startsWith( '#&%2333' ) ) return null

			// const params = new URLSearchParams( hash )
			// const map = params.get('#33;section')?.slice( 12 )

			// const tgWebAppData = new URLSearchParams( params.get( 'tgWebAppData' )! )
			// const user: { 
			// 	id: number,
			// 	first_name: string,
			// 	last_name: string,
			// 	username: string,
			// 	photo_url: string,
			// } = JSON.parse( tgWebAppData.get( 'user' )! )

			const tg = $mol_import.script('https://telegram.org/js/telegram-web-app.js').Telegram.WebApp
			this._tg_params = tg.initDataUnsafe
			
			const decoded = tg_hash_decode( hash )
			const cleaned_hash = decoded.split('&tgWebAppData')[0]
			document.location.hash = cleaned_hash

			return this._tg_params
		}

	}

	function tg_hash_decode( str: string ) {
		let decoded
		do {
			decoded = str
			str = decodeURIComponent( str.replace( /\+/g, ' ' ) )
			str = str.replace( /&#(\d+);/g, ( m, code ) => String.fromCharCode( code ) )
			str = str.replace( /&#x([0-9a-f]+);/gi, ( m, hex ) => String.fromCharCode( parseInt( hex, 16 ) ) )
		} while( decoded !== str && str.includes( '%' ) )
		return str
	}

}
